// Actions
export const KEYWORD_FETCH  = '[Keyword] Fetch'

// Mutations
export const KEYWORD_META   = '[Keyword] meta'
export const KEYWORD_OBTAIN = '[Keyword] obtain'
export const KEYWORD_CLEAR  = '[Keyword] clear'
export const KEYWORD_SET_LOADING = '[Keyword] set loading'
